import { useEffect, useState } from "react";
import { useHeader, useImageUrl } from "../../../queries";
import { MobileMenu } from "./MobileMenu/MobileMenu";
import {
    ArrowIcon,
    Burger,
    Container,
    EmailBtn,
    FixedBtnWrap,
    Icon,
    Link,
    Logo,
    NavWrap,
    ScrollTopBtn,
    Wrap
} from "./styled";

export const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const {data} = useHeader();
    const header = data?.[0] || {};
    console.log("header", header)
    const logoUrl = useImageUrl(header?.logo);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setIsScrolled(currentIsScrolled => {
                if (!currentIsScrolled && scrollY > 250) return true;
                if (currentIsScrolled && scrollY < 200) return false;
                return currentIsScrolled;
            });
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
    }, [isMenuOpen]);

    const scrollToTop = () => {
        window.scrollTo({top: 0, behavior: "smooth"});
    };

    return (
        <Container $scrolled={isScrolled}>
            {/*todo Dima*/}
            <Wrap>
                <Logo to="/" $scrolled={isScrolled} $logoUrl={logoUrl}/>
                {/*<NavWrap>*/}
                {/*    <Link to="/products">PRODUCTS</Link>*/}
                {/*    <Link to="/subscribe">SUBSCRIBE</Link>*/}
                {/*    <Link to="/about-us">ABOUT US</Link>*/}
                {/*    <Link to="/resources">RESOURCES</Link>*/}
                {/*    <Link to="/faq">FAQ</Link>*/}
                {/*    <Link to="/email">EMAIL US</Link>*/}
                {/*    <Link to="/users/login">*/}
                {/*        <Icon width={16} height={17} src={"./icons/login.svg"}/> LOGIN*/}
                {/*    </Link>*/}
                {/*</NavWrap>*/}


                <NavWrap>
                    {header?.links?.map((link, index) => {
                        if (link.href.startsWith('http') || link.href.startsWith('mailto') || link.href.includes('app/login')) {
                            return (
                                <Link key={index} as="a" href={link.href}
                                      target={link.href.startsWith('http') ? '_blank' : undefined}
                                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}>
                                    {link.className && <Icon width={16} height={17} src={"./icons/login.svg"}/>}
                                    {link.title.toUpperCase()}
                                </Link>
                            );
                        }
                        return (
                            <Link key={index} to={link.href}>
                                {link.className && <Icon width={16} height={17} src={"./icons/login.svg"}/>}
                                {link.title.toUpperCase()}
                            </Link>
                        );
                    })}
                </NavWrap>

                <Burger
                    width={18}
                    height={18}
                    src={isMenuOpen ? "./icons/close.svg" : "./icons/burger.svg"}
                    onClick={() => setIsMenuOpen(prev => !prev)}
                />
            </Wrap>

            <MobileMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} header={header}/>

            <FixedBtnWrap $isScrolled={isScrolled}>
                <EmailBtn href={header?.links?.find(l => l.title === 'Email us')?.href || '#'}>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path
                            d="M32 12.679v14.179q0 1.179-0.839 2.018t-2.018 0.839h-26.286q-1.179 0-2.018-0.839t-0.839-2.018v-14.179q0.786 0.875 1.804 1.554 6.464 4.393 8.875 6.161 1.018 0.75 1.652 1.17t1.688 0.857 1.964 0.438h0.036q0.911 0 1.964-0.438t1.688-0.857 1.652-1.17q3.036-2.196 8.893-6.161 1.018-0.696 1.786-1.554zM32 7.429q0 1.411-0.875 2.696t-2.179 2.196q-6.714 4.661-8.357 5.804-0.179 0.125-0.759 0.545t-0.964 0.679-0.929 0.58-1.027 0.482-0.893 0.161h-0.036q-0.411 0-0.893-0.161t-1.027-0.482-0.929-0.58-0.964-0.679-0.759-0.545q-1.625-1.143-4.679-3.259t-3.661-2.545q-1.107-0.75-2.089-2.063t-0.982-2.438q0-1.393 0.741-2.321t2.116-0.929h26.286q1.161 0 2.009 0.839t0.848 2.018z"></path>
                    </svg>
                </EmailBtn>
                <ScrollTopBtn $isScrolled={isScrolled} onClick={scrollToTop} title="Scroll to top">
                    <ArrowIcon version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                               viewBox="0 0 32 32">
                        <path d="M0 20l6 6 10-10 10 10 6-6-16-16z"></path>
                    </ArrowIcon>
                </ScrollTopBtn>
            </FixedBtnWrap>

        </Container>
    );
};
